import moment from 'moment-timezone';
import formatDate from 'helpers/formatDate';
import defaultTextValues from './defaultTextValues';


export default function getContent(payload) {

  if (!payload) return { value: '', hasTextValue: 'default' };

  const {
    typeOfStyle,
    language,
    content,
    editorViewportContent
  } = payload;

  if (editorViewportContent && content && content[typeOfStyle] && editorViewportContent) {

    if (editorViewportContent === '37_5' && content[typeOfStyle][editorViewportContent] && content[typeOfStyle][editorViewportContent][language]) {
      return { value: typeof content[typeOfStyle][editorViewportContent][language] === 'string' ? content[typeOfStyle][editorViewportContent][language] : '', hasTextValue: false };
    }
    if ((editorViewportContent === '76_8' || editorViewportContent === '37_5') && content && content[typeOfStyle]['76_8'] && content[typeOfStyle]['76_8'][language]) {
      return { value: typeof content[typeOfStyle]['76_8'][language] === 'string' ? content[typeOfStyle]['76_8'][language] : '', hasTextValue: false };
    }
  }


  if (content && content[typeOfStyle] && content[typeOfStyle][language]) {
    return { value: typeof content[typeOfStyle][language] === 'string' ? content[typeOfStyle][language] : '', hasTextValue: false };
  } 


  if (content && content[typeOfStyle] && !content[typeOfStyle][language] && typeof content[typeOfStyle] === 'string') {
    return { value: typeof content[typeOfStyle] === 'string' ? content[typeOfStyle] : '', hasTextValue: false };
  }

  // brokenish ? not sure leftoover from dynamiclayouts?
  // if (content && (content[typeOfStyle] || content[typeOfStyle] === 0) && !content[typeOfStyle][language]) {
    // return { value: content[typeOfStyle].toString(), hasTextValue: false };
  // }



  if (content && content.dateFrom && typeOfStyle === 'eventDate') {
    return { value: formatDate(content.dateFrom, null, content.timezone), hasTextValue: false };
  }

  if (content && content.dateFrom && typeOfStyle === 'eventDetails') {
    const thisTitle = content.title ? content.title[language] : '';
    return { value: `${thisTitle}`, hasTextValue: false };
  }

  if (typeOfStyle === 'dateText' && content && content.dateFrom) return moment(content.dateFrom).tz(content.timezone).format('MMMM DD YYYY');

  if (defaultTextValues && defaultTextValues[typeOfStyle] && defaultTextValues[typeOfStyle][language]) {
    return { value: typeof defaultTextValues[typeOfStyle][language] === 'string' ? defaultTextValues[typeOfStyle][language] : '', hasTextValue: defaultTextValues ? true : 'default' };
  }

  return { value: 'Text here', hasTextValue: 'default' };

}
